<template>
  <div class="pointer archive-button button-item-handler white--text no-decoration description hideSmartphone"
       @click="openClientFinancingOffer">
    <app-icon name="print" :size="18" />
    ponuka
  </div>
</template>

<script>
import AppIcon from "@/components/shared/AppIcon.vue";

export default {
  name: "ClientFinancingOfferHandler",
  components: { AppIcon },
  methods: {
    openClientFinancingOffer () {
      this.$store.commit("popupManagerState/toggleClientFinancingOffer", true);
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
